module.exports = __webpack_public_path__ + "static/media/moonless.f5d35b25.mp3";